import { cloudFunction } from '../parse';

export const fetchAllSubscriptionsForAdmin = async (params) => {
  return cloudFunction('fetchAllSubscriptionsForAdmin', params);
};

export const updateSubscription = async (params) => {
  return cloudFunction('updateSubscription', params);
};

export const createSubscription = async (params) => {
  return cloudFunction('createSubscription', params);
};

export const getSubscriptionDetail = async (id: string) => {
  return cloudFunction('getSubscriptionDetail', { id });
};

export const addSubscriptionItemConfig = async (params) => {
  return cloudFunction('addSubscriptionItemConfig', params);
};

export const removeSubscriptionItemConfig = async (params) => {
  return cloudFunction('removeSubscriptionItemConfig', params);
};


export const assignTagToSubscription = (id: string, tagIds: string[]) => {
  return cloudFunction('assignTagToSubscription', { id,tagIds });
};

export const fetchSubscriptionPlanTags = (id) => {
  return cloudFunction('fetchSubscriptionPlanTags', { id });
};

export const removeTagFromSubscription = (id: string, tagId: string) => {
  return cloudFunction('removeTagFromSubscription', { id, tagId });
};
